import { useState } from "react";
import { useShallow } from "zustand/react/shallow";

import { api } from "@api";
import { useNotifyPromise } from "@hooks";
import { IRoleEnum } from "@interfaces";
import { useUserStore } from "@stores/userStore";
import { useAuthStore } from "@templates/authManagement/authStore";
import { StudentVerificationForm } from "@templates/authManagement/studentVerificationForm";

export function StudentVerificationView() {
  const notifyMutate = useNotifyPromise();
  const username = useAuthStore(
    useShallow((state) => state.forgetPasswordMeteData.userName),
  );
  const reqId = useAuthStore(
    useShallow((state) => state.forgetPasswordMeteData.reqId),
  );

  const loginFunc = useUserStore(useShallow((state) => state.login));

  const [isWrong, setIsWrong] = useState(false);

  const { mutateAsync: sendOtp, isPending: isRequestPending } =
    api.auth.signUpApplicant.usePost();
  const { mutateAsync: verify, isPending: isVerifyPending } =
    api.auth.signUpApplicant.signUpApplicantVerify.usePost();

  const onSubmit = (code: string) => {
    notifyMutate(
      verify(
        { pathParam: undefined, code, request_id: reqId },
        {
          onSuccess: (res) => {
            loginFunc(
              res?.data?.access,
              res?.data?.user?.role?.id || IRoleEnum.UNKNOWN,
              res?.data?.user?.id,
              null,
              null,
              null,
            );
          },
          onError: () => {
            setIsWrong(true);
          },
        },
      ),
    ).catch(() => {});
  };

  const onResendCode = async () => {
    await notifyMutate(sendOtp({ pathParam: undefined, email: username }));
  };

  return (
    <StudentVerificationForm
      onSubmit={onSubmit}
      isVerificationLoading={isRequestPending}
      isMutating={isVerifyPending}
      isWrong={isWrong}
      setIsWrong={setIsWrong}
      onResendCode={onResendCode}
    />
  );
}
